import { COMMON_META, TRUST_INTERSTITIAL } from './shared';

// Anti-aging / longevity (NAD+, glutathione, metformin, B12, MIC) — /anti-aging.
const stages = ['Start', 'Goals', 'Health', 'Details', 'Eligibility'];

const meta = {
  ...COMMON_META('Start'),
  'sex-at-birth': { stage: 'Start', headline: ['Feel younger,', 'from the inside out.'], hint: 'Select the option that best describes you.', image: 'antiaging/glow', optionIcons: { male: '👨', female: '👩' } },
  'height-weight': { stage: 'Start', headline: ["Let's find", 'your baseline.'], hint: 'Used only to check eligibility and tailor your treatment.', image: 'common/measure' },
  'primary-reason': { stage: 'Goals', headline: ['What brings you', 'here today?'], hint: 'Select all that apply.', image: 'antiaging/cells' },
  'primary-reason-other': { stage: 'Goals', headline: ['Tell us more about', 'your goal.'], image: 'antiaging/cells' },
  'current-symptoms': { stage: 'Goals', headline: ['Aging shows up', 'in different ways.'], hint: 'Select all that apply.', image: 'antiaging/glow' },
  'current-symptoms-other': { stage: 'Goals', headline: ['Tell us more about', 'what you notice.'], image: 'antiaging/glow' },
  'previous-treatment': { stage: 'Health', headline: ['Have you tried', 'anti-aging therapy before?'], image: 'antiaging/vial' },
  'previous-reaction': { stage: 'Health', headline: ['How did your body', 'respond last time?'], image: 'antiaging/vial' },
  'previous-reaction-details': { stage: 'Health', headline: ['Tell us more about', 'what happened.'], image: 'antiaging/vial' },
  'medical-history': { stage: 'Health', headline: ['A few', 'safety checks.'], image: 'common/health' },
  'cancer-treatment': { stage: 'Health', headline: ['A few', 'safety checks.'], image: 'common/health' },
  'ix-trust': { stage: 'Start' }, 'ix-curve': { stage: 'Goals' }, 'ix-t': { stage: 'Health' },
};

const interstitials = [
  TRUST_INTERSTITIAL('ix-trust', 'allergies', { title: 'Anti-Aging & Longevity', bullets: ['NAD+, glutathione, metformin, B12 and MIC — prescribed by licensed U.S. providers', 'Every intake reviewed within 24 hours', 'Compounded by licensed U.S. pharmacies', 'Free, discreet shipping — no long-term contract'] }),
  {
    id: 'ix-curve', after: 'primary-reason', kind: 'curve', plain: 'How does', accent: 'NAD+ support work?',
    yLabel: ['Cellular', 'energy'], arrowLabel: ['Focus &', 'recovery'], xLabels: ['Week 0', 'Week 2', 'Week 4', 'Week 8'],
    bullets: ['– Weeks 1–2: NAD+ levels are replenished', '– Weeks 2–4: many patients report steadier energy and sharper focus', ['– Week 5+: recovery and ', 'overall vitality build']],
  },
  { id: 'ix-t', after: 'current-symptoms', kind: 'testimonial', quote: ['The 3 p.m. crash ', ['is gone.'], ' I’m sleeping better and ', ['people keep asking what I’m doing differently.']] },
];

const antiAging = {
  key: 'antiAging', route: '/anti-aging', title: 'Anti-Aging & Longevity', stages, fallbackStage: 'Health',
  stageDefaults: {
    Start: { headline: ['Feel younger,', 'from the inside out.'], image: 'antiaging/glow' },
    Goals: { headline: ['What brings you', 'here today?'], image: 'antiaging/cells' },
    Health: { headline: ['Your health history', 'shapes your plan.'], image: 'common/health' },
    Details: { headline: ['Almost there —', 'a few final details.'], image: 'common/consent' },
    Eligibility: { headline: ["You're eligible!", 'Choose your treatment.'], image: null },
  },
  meta, interstitials,
};
export default antiAging;
